import React, { Component, PropTypes } from 'react';
import styled from 'styled-components';
import { NitroDataGrid } from 'nitro-components';
import { media } from 'style-utils';

import {
  TransformText,
  GriddleAction,
  GridHeaderComponent,
  EllipsisText
} from '../../../../components/utils/TableUtils';

const ResultGrid = styled.div`
  ${media.mobileTablet`
    display: none;
    & .griddle .standard-row td{
      padding: 10px 16px;
    }
    & .griddle .pagination .previous {
      margin: 0px 0px;
    }
    & .griddle .pagination .next {
      margin: 0px 0px;
    }
  `}

  & .griddle table {
    border-collapse: collapse;
    border-spacing: 0 15px;
    min-width: 1120px;
  }

  & .griddle .standard-row:last-child {
    border-bottom: 1px solid #d9d9d9;
  }
  & .griddle .standard-row {
    background-color: ${props => props.theme.color.white};
    border-radius: 2px;
    box-shadow: inset 0px 2px 0px 0 rgba(0, 0, 0, 0.15);
    width: 60px;
    height: 46px;
    border-bottom: none;
    &:hover {
      border: 2px solid ${props => props.theme.color.primary};
    }

    td:first-child {
      span {
        color: ${props => props.theme.color.primary};
        font-family: ${props => props.theme.font.default};
      }
    }

    td:nth-child(5) {
      color: ${props => props.theme.color.primary};
      font-family: ${props => props.theme.font.default};
    }
  }

  & .griddle .standard-row:nth-child(even) {
    background-color: ${props => props.theme.color.white};
  }

  & .griddle .griddle-column-bold {
    color: ${props => props.theme.color[props.variant]};
  }

  & .griddle {
    th {
      background-color: #e6eaef;
      text-transform: uppercase;
      font-family: ${props => props.theme.font.bold};
      color: ${props => props.theme.color.gunmetal};
      font-size: 11px;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.82;
      letter-spacing: 0.4px;
    }
  }

  & .griddle-footer .pagination {
    display: flex;
    align-items: center;
    align-content: center;
    & li {
      margin: 0;
      &.previous,
      &.next {
        padding: 9px 8px 3px 8px;
        vertical-align: -webkit-baseline-middle;
        & a {
          & svg {
            g {
              path {
                stroke: ${props => props.theme.color.primary};
              }
            }
          }
        }

        &:hover {
          border: 1px solid ${props => props.theme.color[props.variant]};
        }

        &:after,
        &:before {
          content: '';
          margin-right: 0px;
          margin-left: 0px;
          font: unset;
        }
      }

      &.active {
        background: ${props => props.theme.color.primary};
        color: ${props => props.theme.color.white};
        border: 1px solid #e6e6e6;
        padding: 6px 0px;
        border-radius: 2px;
      }

      &:hover {
        border: 1px solid ${props => props.theme.color[props.variant]};
      }
    }
    margin: 0;
  }

  & .griddle .footer-container {
    padding: 0;
    ${media.mobile`
      position: fixed;
      background: white;
    `}
  }
  & .griddle-footer > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 0;
  }
  & .pagination li > a {
    color: ${props => props.theme.color.primary};
  }
`;

const ResultGridMobile = ResultGrid.extend`
  display: none;

  ${media.mobileTablet`
    display: block;
    & tbody {
      width: 100vw;
      max-height: 80vh;
      overflow: scroll;
    } 
  `}
  .griddle-footer > div {
    flex-direction: column;
    width: 100vw;
    & div {
      padding: 24px 0;
    }
    & ul {
      margin: 0 0 28px 0;
    }
  }
`;
class DetailedSearchResultsGrid extends Component {
  shouldComponentUpdate(nextProps) {
    return !nextProps.shouldNotReRender;
  }

  driverColumnMeta = [
    {
      columnName: 'DriverFullName',
      displayName: 'Driver Name',
      sortable: true,
      customHeaderComponent: GridHeaderComponent,
      customComponent: ({ data }) => <EllipsisText text={data} length={15} />
    },
    {
      columnName: 'DriverEmail',
      displayName: 'Email address',
      sortable: true,
      customHeaderComponent: GridHeaderComponent,
      customComponent: ({ data }) => <EllipsisText text={data} length={20} />
    },
    {
      columnName: 'DriverId',
      displayName: 'Driver ID',
      sortable: true,
      customComponent: TransformText,
      customHeaderComponent: GridHeaderComponent
    },
    {
      columnName: 'MakeModel',
      displayName: 'Vehicle',
      sortable: true,
      customHeaderComponent: GridHeaderComponent
    },
    {
      columnName: 'RegistrationNumber',
      displayName: 'Registration',
      sortable: true,
      customHeaderComponent: GridHeaderComponent
    },
    {
      columnName: 'LeaseId',
      displayName: 'Lease Id',
      sortable: true,
      customHeaderComponent: GridHeaderComponent
    },
    {
      columnName: "LeaseDescription",
      displayName: "Lease Status",
      sortable: false,
      customHeaderComponent: GridHeaderComponent
    },
    {
      columnName: "CostCentre",
      displayName: "Cost Centre",
      sortable: false,
      customHeaderComponent: GridHeaderComponent
    },
    {
      columnName: 'MoreDetails',
      displayName: '  ',
      sortable: false,
      customComponent: () => <GriddleAction content="" />
    }
  ];

  render() {
    return (
      <div>
        <ResultGrid variant={this.props.variant}>
          <NitroDataGrid
            results={this.props.data}
            totalCount={this.props.total}
            rowPerPage={this.props.rowCount}
            columnMetaData={this.driverColumnMeta}
            onRowClick={this.props.onDataRowClick}
            fetchExternalData={this.props.getExternalData}
            currentPage={this.props.currentPage}
            dataFetching={this.props.dataFetching}
            uniqueKey={this.props.type}
          />
        </ResultGrid>
        <ResultGridMobile variant={this.props.variant}>
          <NitroDataGrid
            results={this.props.data}
            totalCount={this.props.total}
            rowPerPage={this.props.rowCount}
            columnMetaData={this.driverColumnMeta}
            onRowClick={this.props.onDataRowClick}
            fetchExternalData={this.props.getExternalData}
            currentPage={this.props.currentPage}
            dataFetching={this.props.dataFetching}
            uniqueKey={this.props.type}
          />
        </ResultGridMobile>
      </div>
    );
  }
}

DetailedSearchResultsGrid.propTypes = {
  dataFetching: PropTypes.bool,
  data: PropTypes.arrayOf(PropTypes.shape({})),
  total: PropTypes.number,
  rowCount: PropTypes.number,
  currentPage: PropTypes.number,
  type: PropTypes.string,
  variant: PropTypes.string,
  getExternalData: PropTypes.func,
  onDataRowClick: PropTypes.func
};

DetailedSearchResultsGrid.defaultProps = {
  dataFetching: false,
  data: [],
  total: 0,
  rowCount: 0,
  type: 'Driver',
  currentPage: 0,
  variant: 'iceBlue',
  getExternalData: () => { },
  onDataRowClick: () => { }
};

export default DetailedSearchResultsGrid;



// WEBPACK FOOTER //
// ./src/features/common/GlobalSearchBar/SearchResultGrid/DetailedSearchResultsGrid.js